export function getInitAuthUrl(url: string, currentPage: string, path: string) {
  try {
    const { origin: authOrigin } = new URL(url);
    const { origin } = new URL(currentPage);

    // хардкод для страниц со своим роутингом на nginx
    if (path.includes('/main-page')) {
      path = '/';
    }

    // хардкод для страниц со своим роутингом на nginx
    if (path.includes('/brandslist')) {
      path = '/brands/';
    }

    return `${authOrigin}/?state=${origin}${path}`;
  } catch (error) {
    return url;
  }
}
